const cancelRequest = ({ctaHandler = null, id = 'cancelRequest'} = {}) => ({
    id,
    type: 'informative',
    options: {
        headerIconClass: 'odf-icon-loading',
        hasCloseIcon: false,
        contentType: 'status',
        hasCTA: !!ctaHandler,
    },
    ctaHandler,
});

const fillNotification = ({notification = {}, keys = {}, status = {}} = {}) => ({
    ...notification,
    keys: {
        headerTitle: keys.changesNotificationTitle,
        ctaText: keys.changesNotificationButtonText,
        statusLabel: keys.changesNotificationStep,
    },
    status,
});

class NotificationFactory {
    create({keys = {}, status = {}, ctaHandler = null, id} = {}) {
        return fillNotification({
            notification: cancelRequest({ctaHandler, id}),
            keys: keys,
            status,
        });
    }
}

module.exports = new NotificationFactory();
